<header class="header-SSBA">
  <!-- Health pillar -->
  <div class="pillar-SSBA"></div>

  <!-- Banner displayed based on viewport size -->
  @if (screenSize() === "desktop" || screenSize() === "tablet") {
    <!-- Desktop banner  -->
    <div class="border-top-SSBA"></div>
    <div class="row" [ngStyle]="{'gap': isDesktop() ? '30px' : '5px'}">
      @if (screenSize() === "desktop") {
        <div class="img-rotated">
          <div>
            <img ngSrc="./assets/SSBA.jpg" alt="SSBA logo" width="75" height="75" priority>
          </div>
          <div>
            <img ngSrc="./assets/SSBA.jpg" alt="SSBA logo" width="75" height="75" priority>
          </div>
        </div>
      }
      <div class="div-margin-left">
        <h1 class="title" [ngStyle]="{'font-size': isDesktop() ? '22px' : '1.9vw'}">Security Sensitive Biological Agents
          Regulatory Scheme</h1>
      </div>

      <div class="header-spacer"></div>

      @if (environment.useMockAuth) {
        <app-mock-auth-ui/>
      }
      <div class="login-container">
        <div class="login-header">
          You are logged in
          <mat-icon class="icon" aria-hidden="false" aria-label="Home" fontIcon="lock"></mat-icon>
          <button (click)="authService.logout()" type="button"><b>Logout</b></button>
        </div>
        <div class="login-content">
          <p>Welcome {{authService.name()}}</p>
        </div>
      </div>
    </div>
  } @else {
    <!-- Mobile banner -->
    <div class="row centre">
      <h1 class="title-mobile">Security Sensitive Biological Agents
      </h1>
    </div>
  }

  <!-- Navigation -->
  <app-nav/>
</header>
